class HeadboardImageUpdater {
    constructor(headboardMatrixData) {
        this.headboardMatrixData = headboardMatrixData;
        this.activeHeadboard = null;
        this.activeFabric = null;

        this.cacheElements();
        this.addEventListeners();
    }

    cacheElements() {
        this.pictureElement = document.querySelector('.js-headboard-image picture');

        if (this.pictureElement) {
            this.sourceElements = this.pictureElement.querySelectorAll('source');
            this.imgElement = this.pictureElement.querySelector('img');
        }
    }

    addEventListeners() {
        document.body.addEventListener('click', (event) => {
            let headboardItem = event.target.closest('#headboard-modal .images-row-headboard .item');
            let fabricItem = event.target.closest('#fabric-modal .images-row-fabric .item');

            if (headboardItem) this.handleSelection(headboardItem, 'headboard');
            if (fabricItem) this.handleSelection(fabricItem, 'fabric');
        });
    }

    handleSelection(item, type) {
        if (!item.classList.contains('active')) return;

        let caption = item.querySelector('.caption').innerText.trim();

        if (!caption) return;

        let formattedText = this.formatText(caption);

        if (type === 'headboard') this.activeHeadboard = formattedText;
        else if (type === 'fabric') this.activeFabric = formattedText;

        this.updateHeadboardImage();
    }

    formatText(text) {
        return text.toLowerCase().replace(/\s+/g, '-');
    }

    updateHeadboardImage() {
        if (!this.activeHeadboard || !this.activeFabric || !this.pictureElement) return;

        let matchedItem = this.headboardMatrixData.find(item =>
            item.headboard === this.activeHeadboard && item.fabric === this.activeFabric
        );

        if (!matchedItem || !matchedItem.image) return;

        let { image } = matchedItem;
        
        if (this.sourceElements.length > 1) {
            this.sourceElements[0].srcset = image['1536x1536']; // Above 1280px
            this.sourceElements[1].srcset = image.large; // Above 1024px
        }

        if (this.imgElement && this.imgElement.src !== image.medium_large) {
            this.imgElement.src = image.medium_large; // Below 1024px
            this.imgElement.srcset = image.medium_large;
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    if (window.location.pathname === '/product/') {
        new HeadboardImageUpdater(headboardMatrixData);
    }
});
